<template lang="pug">
  div.box(v-if="!fuel_enabled")
    v-server-table(
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options"
    )
        template(slot="beforeFilter")
            div.m-l-sm.float-right.mode-filter.width-180
                multiselect(
                    v-model="selectedTags"
                    :options="tagList"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :placeholder="`${trans('report.all_tags')}`"
                    label="name"
                    track-by="id"
                    @close="setTagFilter"
                    selectLabel=""
                    deselectLabel="Remove"
                    :searchable="true"
                )
                    template(
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                    )
                        span.multiselect__single(v-if="values.length && !isOpen")
                            | {{ values.length }}
                            | {{ trans('report.tag_selected') }}

                        span.multiselect__single.hide(v-else)
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import tagMixin from './tag-mixin';
import Feature from '@js/plugins/feature';

const TableName = 'VUETABLE_TAGSALES';
export default {
    mixins: [tagMixin],

    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: ['name', 'parent', 'product_quantity', 'total_sales'],
            options: {
                texts: {
                    title: Feature.hasFeature('fuel')
                        ? 'Sales Category'
                        : 'Product Sales by Tag',
                    description: Feature.hasFeature('fuel')
                        ? 'Shows product sales by category'
                        : 'Shows product sales by tag',
                },
                customFilters: ['outlet_id', 'since', 'until', 'tags_id'],
                useReportFilter: true,
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                headings: {
                    name: this.trans('report.tag'),
                    product_quantity: 'Total product quantity',
                    total_sales: 'Total net sales',
                    parent: this.trans('tag.parent_tag'),
                },
                templates: {
                    parent(h, row) {
                        return require('./parent.jsx')(h, row);
                    },
                },
                pdf_url: Laroute.route(
                    'franchise.report.non_fuel.item.exportTagSalesAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.non_fuel.item.exportTagSalesAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.non_fuel.item.exportTagSalesAsFile',
                    { type: 'XLSX' },
                ),
            },
            selectedTags: [],
        };
    },

    computed: {
        ...mapState('tag', ['tagList']),

        api() {
            return Laroute.route('franchise.report.non_fuel.item.getTagSales');
        },

        fuel_enabled() {
            return Feature.hasFeature('fuel');
        },
    },

    mounted() {
        this.getTagListIfNecessary();
    },

    methods: {
        ...mapActions('tag', ['getTagListIfNecessary']),

        setTagFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'tags_id',
                value: this.selectedTags.map(t => t.id),
            });
        },
    },
};
</script>

<style lang="scss">
@media screen and (max-width: 767px) {
    .mode-filter {
        margin-left: 0 !important;
        margin-right: 0;
        margin-bottom: 0.5rem;
        float: none !important;
    }
}

@media screen and (min-width: 767px) {
    .width-180 {
        width: 180px;
    }
}

.mode-filter {
    .multiselect__select {
        height: 36px;
    }

    .multiselect__tags {
        min-height: 38px;
    }

    .multiselect__placeholder {
        margin-bottom: 7px;
    }
}

.hide {
    display: none;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/vuetable_tag_sales.vue